var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading",on:{"click":_vm.closeLoading}},[_c('img',{staticClass:"cyberboard",attrs:{"src":_vm.images.cyberboard}}),_c('img',{staticClass:"logo",attrs:{"src":_vm.images.logo_square}})])}
var staticRenderFns = []

export { render, staticRenderFns }